/**
 * `TextField`'s integer mask, for the `format` prop.
 *
 * Runs on every keystroke / paste and drops anything non-numeric, so the
 * `inputMode` / `keyboardType` hints (which only affect mobile soft keyboards)
 * are backed up on web and hardware-keyboard input.
 */

/** Digits only, no length cap — for fields whose backend expects integers. */
export const formatInteger = (raw: string): string => raw.replace(/\D/g, '');
